<img v-if="src" :src="src">